import { TeacupSolidIcon } from '@ikyucom/design-system-icons-react'
import { twMerge } from 'tailwind-merge'
import { FilterChip } from './FilterChip'
import { createColor } from './criteria'
import type { FilterCriteria } from './types'

export type UseSetAfternoonTea = () => (afterNoonTea: boolean) => void

export function AfternoonTea({
  useFilterCriteria,
  useAfternoonTea,
  useSetAfternoonTea,
  useEnabledAfternoonTea,
}: {
  useFilterCriteria: () => FilterCriteria | undefined
  useAfternoonTea: () => boolean
  useSetAfternoonTea: UseSetAfternoonTea
  useEnabledAfternoonTea: () => boolean
}) {
  const set = useSetAfternoonTea()
  const hasAfternoonTea = useAfternoonTea()
  const criteria = useFilterCriteria()
  const enabled = useEnabledAfternoonTea()
  const color = createColor({ enabled, isActive: criteria?.afternoonTea })
  if (!hasAfternoonTea) {
    return null
  }

  return (
    <FilterChip onClick={() => set(!criteria?.afternoonTea)} color={color}>
      <div className="flex items-center gap-1">
        <TeacupSolidIcon
          width={13}
          height={13}
          className={twMerge(criteria?.afternoonTea ? 'text-marron-light' : 'text-neutral-600')}
        />
        アフタヌーンティー
      </div>
    </FilterChip>
  )
}
